<template>
  <div id="app">
    <!-- Every Route -->
    <router-view />

    <!-- Loading Icon -->
    <b-loading class="app-loader" :active="loaderIsActive"></b-loading>
  </div>
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: 'Real Estate Investor CRM', // default if not defined on view
    titleTemplate: '%s | Forefront'
  },
  computed: {
    loaderIsActive() {
      // This is connected with router.js, where we set isLoggedIn and appIsInitiated value

      // if unauthorized
      if (!this.$store.state.isLoggedIn && !this.$store.state.appIsInitiated) return false;

      // if authorized
      if (this.$store.state.isLoggedIn) {
        if (this.$store.state.appIsInitiated) return false;

        // for exposed route and it has authorized user
        if (!this.$store.state.appIsInitiated) return false;
      }

      return true;
    }
  },
  mounted() {
    this.checkIfMobile();
    // this.checkIfTablet();
    window.onresize = () => {
      this.checkIfMobile();
      // this.checkIfTablet();
    }
  },
  methods:  {
    checkIfMobile() {
      /** IMPORTANT!! This width also needs to be set in mixins.scss */
      if (window.innerWidth <= 1200 && !this.$store.state.isMobile) {
        this.$store.commit('setIsMobile', true);
      } else if (window.innerWidth > 1200 && this.$store.state.isMobile) {
        this.$store.commit('setIsMobile', false);
      }
    },
    /**
     * We aren't checking for tablet sizes, but I'll leave this here for now
     * until we determine exactly what we are doing for mobile
     */
    // checkIfTablet() {
    //   if (window.innerWidth <= 1023 && !this.$store.state.isTablet) {
    //     this.$store.commit('setIsTablet', true);
    //   } else if (window.innerWidth > 1023 && this.$store.state.isTablet) {
    //     this.$store.commit('setIsTablet', false);
    //   }
    // },
  }
}
</script>
